var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"#9e9e9e","font-size":"0.75rem","font-style":"italic"}},[_vm._v("\n  ** This feature is currently open to all users for free. We may charge for\n  this service in the future\n")])}
var staticRenderFns = []

export { render, staticRenderFns }